import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    contactus: [],
    isContactusLoading: false,
    jobposts: null

}


export const getContactus = createAsyncThunk(
    'get_contactus_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getContactusStart());
            const response = await axios.get(`/forms/get_contactus.php`)
            console.log('response of contactus', response?.data?.data)
            if (response?.data?.status == 'success') {

                dispatch(getContactusSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getContactusFailure(error.response.data.message))
        }
    }
)
export const addContsctUs = createAsyncThunk(
    "addcontactus",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os contactusData ', data)
        try {
            dispatch(addContactusStart());
            const response = await axios.post(`/forms/add_contactus.php`, data);
            dispatch(addContactusSuccess(response.data));
            if (response?.data?.status == 'success') {
                dispatch(getContactus())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addContactusFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const addJobPostings = createAsyncThunk(
    "addcontactus",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os contactusData ', data)
        try {
            const response = await axios.post(`/contactus/add_jobposting.php`, data);
            if (response?.data?.status == 'success') {
                dispatch(getJobPostings())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);


export const getJobPostings = createAsyncThunk(
    'get_jobs_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getJobPostingsStart());
            const response = await axios.get(`/contactus/get_jobposting.php`)

            if (response?.data?.status == 'success') {

                dispatch(getJobPostingsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getJobPostingsFailure(error.response.data.message))
        }
    }
)
const contactusSlice = createSlice({
    name: 'contactus',
    initialState,
    reducers: {
        getContactusStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getContactusSuccess(state, action) {

            state.contactus = action.payload;
            state.isLoading = false;
        },
        getContactusFailure(state, action) {
            state.contactus = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getJobPostingsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getJobPostingsSuccess(state, action) {

            state.jobposts = action.payload;
            state.isLoading = false;
        },
        getJobPostingsFailure(state, action) {
            state.jobposts = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addContactusStart(state) {
            state.isContactusLoading = true;
            state.error = null;
        },
        addContactusSuccess(state, action) {
            state.user = action.payload;
            state.isContactusLoading = false;
        },
        addContactusFailure(state, action) {
            state.error = action.payload;
            state.isContactusLoading = false;
        },


    }
})

export const { getContactusSuccess, getContactusStart, getContactusFailure, getJobPostingsSuccess, getJobPostingsStart, getJobPostingsFailure, addContactusStart, addContactusSuccess, addContactusFailure } = contactusSlice.actions;

export default contactusSlice.reducer;